import { gql } from "@grandvisionhq/graphql";
const storeOfferById = gql`
  fragment StoreOfferById on Store {
    offers {
      title
      description
      url
      imageUrl
    }
  }
`;
const GET_STORE_OFFER_BY_ID = gql`
  query GetStoreOfferById($globalStoreId: ID) {
    store(globalStoreId: $globalStoreId) {
      ...StoreOfferById
    }
  }
  ${storeOfferById}
`;
export {
  GET_STORE_OFFER_BY_ID
};
//# sourceMappingURL=get-store-offer-by-id.js.map
